import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { BaseParamsService } from '@app/core/base-params.service';
import { toCamelCasedKeys } from '@app/shared/utils/to-camel-cased-keys';
import { ApiProgram } from '@app/programs/views/models/api-program';
import { LOCALE_HEADER, LOYALTY_CLUB_SLUG_HEADER } from '@app/core/consts';

export interface ApiProgramConfirmationSaveData {
  email: string;
  token: string;
  programId: string;
}

export interface ApiProgramConfirmationResponse {
  newProfile: boolean;
  member: {
    id: number;
  };
}

const BASE_URL = [environment.webforms_api, 'v1', 'members', 'programs'];

export enum ProgramError {
  'not_found' = 'not_found',
  'unknown' = 'unknown'
}

export const errorTypeDictionary: { [key: string]: ProgramError } = {
  'Program not found': ProgramError.not_found,
};

@Injectable({
  providedIn: 'root',
})
export class ProgramsApiHttpService {
  private httpClient = inject(HttpClient);
  private baseParamsService = inject(BaseParamsService);


  public confirm({
                   programId,
                   ...payload
                 }: ApiProgramConfirmationSaveData): Observable<ApiProgramConfirmationResponse> {
    return this.httpClient.post<{ new_profile: boolean; member: { id: number } }>(
      [...BASE_URL, programId, 'registrations', 'confirm'].join('/'),
      payload,
      {
        headers: { [LOYALTY_CLUB_SLUG_HEADER]: this.baseParamsService.slug },
      },
    ).pipe(
      map(response => ({
        newProfile: response.new_profile,
        member: response?.member,
      })),
    );
  }

  public getTerms(programId: number): Observable<ApiProgram> {
    return this.httpClient.get<{ program: ApiProgram }>(`${environment.webforms_api}/v1/loyalty_clubs/programs/${programId}`,
      { headers: this.prepareHeaders() })
      .pipe(
        map((data: { program: ApiProgram }) => toCamelCasedKeys(data.program)),
        catchError(error => throwError(errorTypeDictionary[error?.error?.error] || ProgramError.unknown)),
      );
  }

  private prepareHeaders(): HttpHeaders {
    return new HttpHeaders({
      [LOYALTY_CLUB_SLUG_HEADER]: this.baseParamsService.slug,
      [LOCALE_HEADER]: this.baseParamsService.language || '',
    });
  }
}
